// extracted by mini-css-extract-plugin
export default {"container":"m9-z","productName":"n9-z","price":"o9-z","dimensions":"p9-z"};